<template>
  <div class="footer">
    <div class="footer_inner">
      <div class="footer-top">
        <div class="ft-logo">
          <img src="@/assets/images/logoCompany.svg" alt="" />
          <img src="@/assets/images/logo.svg" alt="" />
        </div>
        <p class="txt">
          <strong> 하이콘소프트는</strong> 여러분의 연락을 <br />
          기다리고 있습니다.
        </p>
      </div>
      <div class="footer-bot">
        <dl>
          <dt>Address</dt>
          <dd>
            하이콘소프트 서울 본사 (07788) 서울 강서구 마곡중앙로 165
            마곡프라이빗타워 1차 13층 (마곡동)
          </dd>
        </dl>
        <dl class="footer-email">
          <dt>Email</dt>
          <dd>
            <a href="mailto:cs@hyconsoft.com" class="footer-email__link">
              <img
                src="@/assets/images/footer-email-cs.png"
                alt="cs@hyconsoft.com"
              />
            </a>
          </dd>
        </dl>
        <dl class="footer-contact">
          <dt>Contact us</dt>
          <dd>
            <img
              src="@/assets/images/footer-contact-phone.png"
              alt="070-8846-5577"
            />
          </dd>
        </dl>
      </div>
    </div>
    <div class="copyright">
      <div class="container">
        Copyright ⓒ 2023 HYCONSOFT. All rights reserved
        <router-link to="/tech/privacyContent"
          ><p class="link">개인정보 처리방침</p></router-link
        >
      </div>
    </div>
    <button type="button" class="btn__top" @click="scrollToTop">
      <i class="material-icons">expand_less</i> TOP
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    scrollToTop() {
      /* 스크롤탑 페이지별 동적구성 */
      const path = this.$route.path;
      if(path.indexOf('privacyContent') !== -1){
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // 부드러운 스크롤 효과를 위해 'smooth' 옵션 사용
        });
      }else{
        const topBtn = document.querySelector('.top-menu');
        topBtn.firstElementChild.click();
      }
    },
  },
  created(){
    this.scrollToTop()
  }
};
</script>

<style></style>
